
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import isURL from 'validator/lib/isURL'
import {siteDeleteConfirm, closeModal} from 'redux/modules/ui/modal/actions'
import {showToast} from 'redux/modules/ui/toaster/actions'
import {reduxForm, Field, SubmissionError} from 'redux-form'
import SlideContainer from 'components/SlideContainer'
import FormInput from 'components/FormInput'
import FormSelect from 'components/FormSelect'
import accountImage from 'components/Icon/images/account.svg'
import {fetchSites, addSite, editSite} from 'redux/modules/sites/actions'
import {currencies} from 'currency-formatter'
import moment from 'moment-timezone'
import sortBy from 'lodash/sortBy'
import tz from 'utils/tz'

const VALIDATOR_URL_SETTINGS = {
  protocols: ['http', 'https'],
  allow_underscores: true
}

const currenciesList = currencies.map(({code, symbol}) => {
  return {name: `${code} (${symbol})`, value: code}
})

const now = moment.utc()
const timezoneList = tz.map(item => {
  const date = moment.tz(now, item)
  const offset = date.format('Z')
  return {name: `(GMT ${offset}) ${item}`, value: item, offset}
})

const sortedTimezoneList = sortBy(timezoneList, ['offset'])

export class SiteAddView extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    processing: PropTypes.bool,
    siteDeleteConfirm: PropTypes.func,
    siteId: PropTypes.string,
    editForm: PropTypes.bool,
    error: PropTypes.string,
    name: PropTypes.string
  }

  render() {
    const {closeModal, editForm} = this.props

    return (
      <SlideContainer
        key='addSite'
        className='site-add-view'
        title={editForm ? 'Edit Merchant Site' : 'Add Merchant Site'}
        icon={accountImage}
        onCloseModal={closeModal}
      >
        <div className='site-add-view_content'>
          {this.renderForm()}
          {this.renderDeleteSection()}
        </div>
      </SlideContainer>
    )
  }

  renderForm() {
    const {
      handleSubmit,
      closeModal
    } = this.props

    return (
      <form className='site-add-view_form' onSubmit={handleSubmit}>
        <Field label='Name' name='name' component={FormInput} />
        <Field label='URL' name='url' component={FormInput} disabled />
        <Field
          label='Time Zone'
          name='timezone'
          component={FormSelect}
          options={sortedTimezoneList}
          searchable
          disabled
        />
        <Field label='Currency' name='currency' component={FormSelect} searchable options={currenciesList} />

        <div className='site-add-view_form_buttons'>
          {this.renderFormButtons()}
          <button type='button' className='site-add-view_form_cancel' onClick={closeModal}>Cancel</button>
        </div>
        {this.renderError()}
      </form>
    )
  }

  renderFormButtons() {
    const {processing, invalid, editForm} = this.props

    return (
      <button
        type='submit'
        className='site-add-view_form_submit'
        disabled={processing || invalid}
      >
        {(editForm) ? 'Save changes' : 'Add site'}
      </button>
    )
  }

  renderDeleteSection() {
    const {editForm, processing} = this.props
    if (!editForm) return null

    return (
      <div className='site-add-view_delete'>
        <div className='site-add-view_delete_title'>
          Delete site
        </div>
        <div className='site-add-view_delete_text'>
          To delete this site, use the button below.
          Please note all data associated with the Site will be deleted permanently.
        </div>
        <div className='site-add-view_delete_action'>
          <button
            className='site-add-view_delete_button is-red'
            onClick={this.onDeleteClick}
            disabled={processing}
          >
            Delete Site
          </button>
        </div>
      </div>
    )
  }

  renderError() {
    const {error} = this.props
    if (!error) return null

    return <div className='site-add-view_error'>{error}</div>
  }

  onDeleteClick = () => {
    const {siteId, siteDeleteConfirm, name} = this.props
    siteDeleteConfirm({siteId, name})
  }
}

const mapStateToProps = state => {
  return {
    processing: state.account.isSiteAddProccessing ||
      state.account.isSiteDeleteProccessing ||
      state.account.isSiteEditProccessing,
    errorMessage: state.account.isSiteAddProccessingErrorMessage ||
      state.account.isSiteDeleteProccessingErrorMessage ||
      state.account.isSiteEditProccessingErrorMessage
  }
}

export default connect(mapStateToProps, {
  closeModal,
  siteDeleteConfirm,
  fetchSites
})(reduxForm({
  form: 'addSite',
  validate: ({name, url, timezone, currency}) => {
    const errors = {}

    if (!name) {
      errors.name = 'Please provide name of your site'
    }

    if (!url) {
      errors.url = 'Please provide url of your site'
    } else if (!isURL(url, VALIDATOR_URL_SETTINGS)) {
      errors.url = 'URL is not correct'
    }

    if (!timezone) {
      errors.timezone = 'Please select timezone'
    }

    if (!currency) {
      errors.currency = 'Please select currency'
    }

    return errors
  },
  onSubmit: (fields, dispatch, props) => new Promise((resolve, reject) => {
    const {siteId, editForm} = props

    if (editForm) {
      dispatch(editSite({...fields, id: siteId}))
        .success(() => {
          dispatch(closeModal())
          dispatch(showToast(`${fields.name} was successfully updated`))
          resolve()
        })
        .fail(err => reject(new SubmissionError({_error: err.message})))
    } else {
      dispatch(addSite(fields))
        .success(() => {
          dispatch(closeModal())
          dispatch(showToast(`${fields.name} was successfully added`))
          resolve()
        })
        .fail(err => reject(new SubmissionError({_error: err.message})))
    }
  })
})(SiteAddView))



// WEBPACK FOOTER //
// ./client/modals/SiteAddView/index.js